export const CEP = 'CEP';
export const ENDERECO = 'Endereço';
export const NUMERO = 'Número';
export const COMPLEMENTO = 'Complemento';
export const BAIRRO = 'Bairro';
export const CIDADE = 'Cidade';
export const ESTADO = 'Estado';
